import React from 'react'
import { find } from 'lodash'
import Timer from '~/components/Timer/timer-svg'

const ScheduleItem = ({ item, maxWidth }) => {
  const duration = find(item.tags, item => item.tagType === 'classDuration');
  const gist = item.gist;
  const url = `${gist.imageGist["_32x9"] || gist.imageGist["_16x9"]}?impolicy=resize&w=${1200}&h=${1200 * 0.28125}`;
  
  return <a className="carousel-item schedule-carousel" href={gist.permalink}>
      <div className="image">
        <img src={url} data-src={url} className="lazy desktop-image" alt={gist.title} />
        <img src={`${gist.imageGist["_16x9"]}?impolicy=resize&w=${1000}&h=${1000 * 0.5625}`} data-src={`${gist.imageGist["_16x9"]}?impolicy=resize&w=${1000}&h=${1000 * 0.5625}`} className="lazy mobile-image" alt={gist.title} />
        <div className="schedule-info">
          {(gist.contentType !== "PERSON" && gist.contentType!== 'SERIES') && <div className="duration">
              {duration && <span className="item">{duration.title}</span>} {gist.primaryCategory && gist.primaryCategory.title && <span className="item">
                    {" "}
                    {gist.primaryCategory.title}
                  </span>}
            </div>}
          {gist.scheduleStartDate && <Timer scheduleStartDate={gist.scheduleStartDate} scheduleEndDate={gist.scheduleEndDate} />}
        </div>
      </div>
    </a>;
}

export default ScheduleItem;

